export default "__VITE_ASSET__CXHncx____"